if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.productData = JSON.parse(document.getElementById('product-data-json').textContent);

      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }
      
      get selectedVariantId() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.variantId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      getSelectedVariant() {
        return this.productData.variants.find(
          (variant) => JSON.stringify(variant.id) === JSON.stringify(this.selectedVariantId)
        );
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          console.log(this.selectedOptionValues)
          console.log(this.productData)
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
        
            
            
            const selectedVariant = this.getSelectedVariant();
          
            console.log('selectedVariant:', selectedVariant);

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
              variant: selectedVariant,
            },
          });

          this.dispatchEvent(
            new CustomEvent('variant:changed', {
              bubbles: true,
              detail: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
                variant: selectedVariant,
              },
            })
          );
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');

          target.selectedOptions[0].setAttribute('selected', 'selected');
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
